// pages/Login.tsx
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { setCache } from "../util/Cache"; 

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")

  const fetchUser = async () => {
    const myHeaders = new Headers();

    const formdata = new FormData();
    formdata.append("username", username);
    formdata.append("password", password);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow" as RequestRedirect
    };

    return await fetch( process.env.REACT_APP_API_URL + "/sapto/user", requestOptions)
      .then((response) => response.json())
      .then((result) => result)
      .catch((error) => { return { status : 500, error } });
  } 

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    console.log("Login dengan:", { username, password })
    const dataPegawai = await fetchUser().then((res) => res.data[0]);
    // console.log({ nama : dataPegawai.nama, username : dataPegawai.opr, loket : dataPegawai.loket, level : dataPegawai.lvl });
    setCache('current_user', { nama : dataPegawai.nama, username : dataPegawai.opr, loket : dataPegawai.loket, level : dataPegawai.lvl });
    navigate("/dashboard");
  }

  return (
    <div style={{ maxWidth: "400px", margin: "50px auto", textAlign: "center" }}>
      <h2>Halaman Login</h2>

      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          style={{ padding: "8px" }}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ padding: "8px" }}
        />

        <button type="submit" style={{ padding: "10px", cursor: "pointer" }}>
          Login
        </button>
      </form>
    </div>
  )
}
